import React from 'react';
import Button from '../../components/button/button.jsx';
import SimpleCarousel from '../../components/simplecarousel/simplecarousel.jsx';
import './hotspotcarousel.scss'


class HotspotCarousel extends React.Component {

	constructor(props){
		super(props);

		this.slideCount = props.data.slides.length;

		this.state = {
			hostpotsVisible : true,
			activeSlide : 0,
			transition : 'none'
		};

	}

	componentDidMount(){
		window.addEventListener('Component.HotspotCarousel.NextSlide', () => this.nextSlide(), false);
		window.addEventListener('Component.HotspotCarousel.PreviousSlide', () => this.previousSlide(), false);
	}

	render(){
	
		return 	<section className="component hotspotcarousel">
					<article className="inner">
						<div className="carousel" style={{backgroundImage : 'url(./' + this.props.data.background + ')'}}>
							
							<div className="slides" data-transition={this.state.transition}>
								
								{this.buildSlides(this.props.data.slides)}
								
								<div className="transition" style={{backgroundImage: 'url(./' + this.props.data.transition.spritesheet + ')'}}>
									<img src={'./' + this.props.data.transition.placeholder} alt='transition'/>
								</div>
							</div>
							
							<div className="cta">
								<Button icon={this.props.data.button.icon} text={this.props.data.button.text} className={this.props.data.button.class} clickEvent={this.props.data.button.clickEvent}/>
							</div>

							<div className="nav">
								{this.props.data.slides.map((slide, i) => {
									return <Button key={i} icon={slide.button.icon} text={slide.button.text} clickEvent={'Component.HotspotCarousel.NextSlide'} className={this.state.activeSlide === i ? 'is-active' : ''}/>
								})}
							</div>

							<div className="arrows">
								<Button icon={'caret-left'} className="next" clickEvent={'Component.HotspotCarousel.NextSlide'}/>
								<Button icon={'caret-right'} className="previous" clickEvent={'Component.HotspotCarousel.PreviousSlide'}/>
							</div>
						</div>
						
						<header>
							<h1>{ this.props.data.title }</h1>
							<p>{ this.props.data.copy }</p>
							<SimpleCarousel items={this.props.data.carousel.images} timeout={this.props.data.carousel.timeout}/>
						</header>
					</article>
				</section>
	}

	buildSlides(slides){
		return slides.map((slide, i) => {
			return <div key={i} className="slide" data-index={i} data-active={this.state.activeSlide === i}>
					<img src={ './' + slide.img } alt={ slide.title }/>
					
					<div className="hotspots" data-visible={this.state.hostpotsVisible}>

						{slide.hotspots.map((hotspot, j) => {
							return 	<div key={j} className="hotspot" style={{left: hotspot.coords[0]+'%', top: hotspot.coords[1]+'%'}} onClick={e => this.showGallery(i, j)} data-side={hotspot.coords[0] < 50 ? 'left' : 'right'}>
										<i className="icon">
											<span className="circle"></span>
											<img src={ hotspot.img } alt={ hotspot.name }/>
										</i>
										
										<span className="detail" style={{transform: 'translateY(-' + hotspot.coords[1] + '%)'}} data-side={hotspot.coords[0] < 50 ? 'left' : 'right'}>
											<span className="circle"></span>
											<span className="line" style={{transform: 'rotate(' + ((hotspot.coords[0] < 50 ? -5 + hotspot.coords[1]/10 : 5 - hotspot.coords[1]/10)) + 'deg)'}}></span>
											<span className="name">{ hotspot.name }</span>
											<span className="info">{ hotspot.text }</span>
										</span>
									</div>
						})}
					</div>
				</div>
		})
	}


	showGallery(slide, hotspot){
		window.dispatchEvent(new CustomEvent("Component.ProductGallery.Open", {detail: {slides : this.props.data.slides[slide].hotspots[hotspot].gallery, products : this.props.data.products} }));
	}

	openVideo(){
		window.dispatchEvent(new CustomEvent('Header.Video.Play'));
	}

	nextSlide(){
		this.changeSlide(this.state.activeSlide >= this.slideCount - 1 ? 0 : this.state.activeSlide + 1);
	}

	previousSlide(){
		this.changeSlide(this.state.activeSlide <= 0 ? this.slideCount - 1 : this.state.activeSlide - 1);
	}


	// change slide based on index
	changeSlide(i){
		this.setState({
			hostpotsVisible : false
		}, ()=>{
			
			// hotspot timeout
			window.setTimeout(() => {
				
				this.setState({
					transition : this.state.activeSlide > i ? 'backwards' : 'forwards',
					activeSlide : i
				}, ()=>{
					window.setTimeout(() => {
						this.setState({
							transition : 'none',
							hostpotsVisible : true
						})
					}, 280)
				})
			}, 100)
		})
	}

}

export default HotspotCarousel;


// WEBPACK FOOTER //
// ./src/blocks/hotspotcarousel/hotspotcarousel.jsx